export default __webpack_public_path__ + "static/media/logos_php.e6be1ece.svg";